import React from "react";
import { useOutlet } from "react-router-dom";
import CustomDataTable from "../../components/CustomDataTable/CustomDataTable";
import SubChildLayout from "../../components/SubChildLayout/SubChildLayout";
import { ENDPOINT } from "../../services/endPoints";


const HospitalList = () => {
  const outlet = useOutlet();

  const excludedKeys = ['id', 'password', "hospital_email_id", "password", "hospital_contact", "hospital_contact_person_name","hospital_zio_code", "isActivated",
  
   'updatedAt', 'deletedAt', "createdAt", "year"];

  const compareValue = ["hospital_id", "hospital_Name" , "hospital_address", "hospital_region","status","hospital_code"];
  const customKeyName = {
    hospital_id: "ID",
    hospital_Name: "Name",
    hospital_address: "Address",
    hospital_region: "Region",
    status: "Status",
    hospital_code: "Facility Code",
  };

  const customWidth = {
    hospital_id: "10px",
    hospital_Name: "200px",
     hospital_address: "350px",
     hospital_region: "50px",
     hospital_code: "120px",
     status: "50px",
  };

  return (
    outlet || (
      <>
        <SubChildLayout path={"/hospital-list/add"} buttonName={"Add Facility"}>
          <CustomDataTable
            tableTitle={"List of Referral Facilities"}
            endPoint={ENDPOINT.HOSPITAL}
            filterKey={"hospital_Name"}
            excludedKeys={excludedKeys}
            customKeyName={customKeyName}
            compareValue={compareValue}
            customWidth={customWidth}
          />
        </SubChildLayout>
      </>
    )
  );
};

export default HospitalList;
